import React from "react";
import { useTranslation } from "react-i18next";

type Attachment = File;

interface AttachmentsListProps {
  attachments: Attachment[];
}

const AttachmentsList = ({ attachments }: AttachmentsListProps) => {
  const [t] = useTranslation();
  return (
    <div className="sm:col-span-2">
      <dt className="text-sm font-medium text-slate-500">
        {t("global:shared.FileUpload.Attachments", "Attachments")}
      </dt>
      <dd className="mt-1 text-sm text-slate-900">
        <ul className="divide-y divide-slate-200 rounded-md border border-slate-200">
          {attachments.map((attachment) => (
            <li
              key={attachment.name}
              className="flex items-center justify-between py-3 pl-3 pr-4 text-sm"
            >
              <div className="flex w-0 flex-1 items-center">
                <div
                  data-testId="paperclip-icon"
                  className="icon-[ph--placeholder] h-5 w-5 flex-shrink-0 text-slate-400"
                  aria-hidden="true"
                />
                <span className="ml-2 w-0 flex-1 truncate">
                  {attachment.name}
                </span>
              </div>
              <div className="ml-4 flex-shrink-0">
                <a
                  href={attachment.name}
                  className="font-medium text-blue-600 hover:text-blue-500"
                >
                  {t("global:shared.FileUpload.Download", "Download")}
                </a>
              </div>
            </li>
          ))}
        </ul>
      </dd>
    </div>
  );
};

export default AttachmentsList;
